export const convertSecondsToMinutesAndSeconds = (seconds: number | undefined) => {
  if (!seconds) return;
  const minutes = Math.floor(seconds / 60);
  const secondsValue = Math.round(seconds % 60);
  return {
    minutes,
    seconds: secondsValue,
  };
};
